import { render } from "./ShoppingCart.vue?vue&type=template&id=04310806&scoped=true"
import script from "./ShoppingCart.vue?vue&type=script&lang=js"
export * from "./ShoppingCart.vue?vue&type=script&lang=js"

import "./ShoppingCart.vue?vue&type=style&index=0&id=04310806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04310806"]])

export default __exports__